import { Button, Flex, Grid, TextField } from "@aws-amplify/ui-react";
import { useEffect, useState } from "react";
import { DayPicker } from "react-day-picker";
import { es } from "date-fns/locale";
import LocalizedStrings from "react-localization";
import moment from "moment";

import "react-day-picker/dist/style.css";

const DateRangeForm = ({
  initialValues,
  onSubmit,
  withHours = false,
  content,
}) => {
  const [options, setOptions] = useState(initialValues?.options ?? {});
  const [dateRange, setDateRange] = useState({
    from: moment().startOf("day").toDate(),
    to: moment().endOf("day").toDate(),
  });

  const onSelectDate = (range, daySelected) => {
    if ((!range?.from || !range?.to) && daySelected)
      range = { from: daySelected, to: daySelected };
    setDateRange({
      from: moment(range.from).startOf("day").toDate(),
      to: moment(range.to).endOf("day").toDate(),
    });
  };

  const onTimeChange = (e) => {
    let { name, value } = e.target;
    if (name === "hourFrom") {
      name = "from";
      value = moment(dateRange.from)
        .set({
          hour: parseInt(value.split(":")[0]),
          minute: parseInt(value.split(":")[1]),
          second: 0,
        })
        .toDate();
    } else if (name === "hourTo") {
      name = "to";
      value = moment(dateRange.to)
        .set({
          hour: parseInt(value.split(":")[0]),
          minute: parseInt(value.split(":")[1]),
          second: 0,
        })
        .toDate();
    }
    setDateRange((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    if (initialValues?.from) {
      const { from, to } = initialValues;
      setDateRange({ from, to });
    }
  }, [initialValues]);

  return (
    <Grid padding="10px">
      <DayPicker
        style={{ justifySelf: "center", marginTop: "0px" }}
        locale={es}
        id="datePicker"
        mode="range"
        defaultMonth={initialValues?.from ?? new Date()}
        selected={dateRange}
        onSelect={onSelectDate}
      />

      {withHours && (
        <Flex
          rowGap={10}
          style={{
            justifySelf: "center",
            marginBottom: "15px",
          }}
        >
          <TextField
            type="time"
            name="hourFrom"
            label={strings.fields.startSchedule.label}
            value={moment(dateRange.from).format("HH:mm")}
            onChange={onTimeChange}
          ></TextField>
          <TextField
            type="time"
            name="hourTo"
            label={strings.fields.endSchedule.label}
            value={moment(dateRange.to).format("HH:mm")}
            onChange={onTimeChange}
          ></TextField>
        </Flex>
      )}

      {typeof content === "function" && (
        <div style={{ justifySelf: "center", marginBottom: 16 }}>
          {content({ options, setOptions })}
        </div>
      )}

      <Flex style={{ justifySelf: "center" }}>
        <Button
          children={strings.fields.buttons.save}
          onClick={() => onSubmit({ ...dateRange }, { ...options })}
          variation="primary"
          isDisabled={!dateRange?.from || !dateRange?.to}
        ></Button>
      </Flex>
    </Grid>
  );
};

const strings = new LocalizedStrings({
  es: {
    fields: {
      startDate: {
        label: "Fecha Inicio",
      },
      endDate: {
        label: "Fecha Fin",
      },
      startSchedule: {
        label: "Hora de Inicio",
      },
      endSchedule: {
        label: "Hora de Fin",
      },
      buttons: {
        save: "Guardar",
      },
    },
  },
});

export default DateRangeForm;
